module.exports = __webpack_public_path__ + "img/left-back-icon.72e169bc.svg";